<template>
    <div>

        <div class="em-separator separator-dashed"></div>

        <span>
            {{ yesNoAnswer }}
        </span>

        <div class="form-group row d-flex align-items-center">
            <div class="col-lg-12">
                <div class="row">
                        <div class="col-lg-1 col-chkbx hide-question-chbx">
                                <label class="styled-checkbox">
                                <input type="checkbox" :checked="hide_qn" @change="$emit('update:hide_qn', $event.target.checked)">
                                <span class="checkmark"></span>
                                </label>
                                <i class="fa fa-eye-slash"></i>
                        </div>
                        <div class="col-lg-11 form-control-label">
                            <label>
                                {{ question }}
                            </label>
                            <small v-if="note"><br>{{ note }}</small>
                        </div>
                </div>
            </div>

            <div class="col-lg-1 col-chkbx">
                <label class="styled-checkbox">
                    <input type="checkbox" :checked="action_plan" @change="$emit('update:action_plan', $event.target.checked)">
                    <span class="checkmark"></span>
                </label>
            </div>
            <div class="col-lg-11">
                <ul class="radio-as-buttons">
                    <li class="template-option--li">
                        <input type="radio"
                               value="Yes"
                               v-bind:id="id + '-yes'"
                               v-model="yesNoAnswer"
                        >
                        <label v-bind:for="id + '-yes'">Yes</label>
                    </li>
                    <li class="template-option--li">
                        <input type="radio"
                               value="No"
                               v-bind:id="id + '-no'"
                               v-model="yesNoAnswer"
                        >
                        <label v-bind:for="id + '-no'">No</label>
                    </li>
                    <li class="template-option--li">
                        <input type="radio"
                               value="N/A"
                               v-bind:id="id + '-na'"
                               v-model="yesNoAnswer"
                        >
                        <label v-bind:for="id + '-na'">N/A</label>
                    </li>
                </ul>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'id',
            'question',
            'note',
            'action_plan',
            'hide_qn'
        ],
        data() {
            return {
                yesNoAnswer: this.value,
            }
        },
        watch: {
            yesNoAnswer(val) {
                this.$emit('input', val);
            },
        },
    }
</script>